module.exports = __webpack_public_path__ + "img/imghuodgz-xz.bfe42de4.png";